export function getClerkErrorMessage(error) {
  const first = error?.errors?.[0];
  if (first?.longMessage) return first.longMessage;
  if (first?.message) return first.message;
  return error?.message || 'Something went wrong. Please try again.';
}
